import React from 'react';

const SettingsHeader = () => (
  <h1 className="c-settings__header">Settings</h1>
);

export default SettingsHeader;